import { render } from "./edit_tax_component.vue?vue&type=template&id=57633a26&scoped=true"
import script from "./edit_tax_component.vue?vue&type=script&lang=js"
export * from "./edit_tax_component.vue?vue&type=script&lang=js"

import "./edit_tax_component.vue?vue&type=style&index=0&id=57633a26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57633a26"]])

export default __exports__